// Blog API client. All endpoints are public (no auth headers required).
// Backend: server/api.js — GET /api/blog/posts, /api/blog/posts/:slug.

export async function getBlogPosts({ search, tag } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (tag) params.set('tag', tag);
  const qs = params.toString();
  const res = await fetch(`/api/blog/posts${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error('Failed to load blog posts');
  return res.json();
}

export async function getBlogPost(slug) {
  const res = await fetch(`/api/blog/posts/${encodeURIComponent(slug)}`);
  if (!res.ok) throw new Error('Post not found');
  return res.json();
}
